import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { PostActivitySharedDTO } from './Post-activity-shared.dto';
import {PostActivityDTO} from './post-activity.dto';
export class PostActivityResponseModel extends GlobalResponseObject {
  data?: PostActivityDTO;
  response: PostActivityDTO[];
}
export class PostActivitysharedResponseModel extends GlobalResponseObject {
  data?: any;
  response: any[];
}



